export enum TextColor {
  Main = '#333D47',
  Black = '#20262D',
  Grey = '#696974',
  DarkGrey = '#44444F',
  LightGrey = '#92929D',
  SlateGrey = '#5D7083',
  Blue = '#1E96FC',
  RoyalBlue = '#538BFF',
  Green = '#23A566',
  Red = '#FC5A5A',
  Error = '#FF0000',
  DeepRed = '#D72638',
  Orange = '#FF9F29'
}
